import View from './view';

export const PollsTypeView = View;
